import { Panel, PanelProps } from 'react-resizable-panels';

import { DRAWER_WIDTH } from 'src/constants';

const MIN_WIDTH_IN_PIXELS = 288;
const DEFAULT_WIDTH_IN_PIXELS = 396;
const DESKTOP_MAX_WIDTH_PERCENTAGE = 55;
const MOBILE_MAX_WIDTH_PERCENTAGE = 100;
/**
 * Calculates responsive size constraints for the right panel based on viewport width.
 *
 * Mobile (< 600px): Returns 100% width
 * Desktop: Converts fixed pixel widths to percentages of available space
 *   - Min: 288px → percentage of (viewport width - 200px sidebar)
 *   - Default: 396px → percentage of (viewport width - 200px sidebar)
 *   - Max: 55% of available space
 *
 * @param viewPortWidth - Current viewport width in pixels
 * @returns Panel size configuration object with minSize, maxSize, and defaultSize in percentages
 */
export const getRightPanelSizeProps = (
  viewPortWidth: number,
  isMobile: boolean,
) => {
  if (isMobile) {
    return { minSize: MOBILE_MAX_WIDTH_PERCENTAGE };
  }

  // if viewPortWidth is not available, return default sizes
  if (!viewPortWidth) {
    return { minSize: 20, maxSize: 55, defaultSize: 30 };
  }

  const minWidthInPercentage =
    (MIN_WIDTH_IN_PIXELS / (viewPortWidth - DRAWER_WIDTH)) * 100;
  const defaultWidthInPercentage =
    (DEFAULT_WIDTH_IN_PIXELS / (viewPortWidth - DRAWER_WIDTH)) * 100;
  return {
    minSize: minWidthInPercentage,
    maxSize: DESKTOP_MAX_WIDTH_PERCENTAGE,
    defaultSize: defaultWidthInPercentage,
  };
};

export const ResizablePanel = ({
  children,
  className,
  ...props
}: { children: React.ReactNode; className?: string } & PanelProps) => {
  return (
    <Panel {...props} className={className}>
      {children}
    </Panel>
  );
};
